/**
 * Top Courses Component
 * Displays top recorded courses with hours and activity counts
 */

import { Box, Paper, Card, Typography } from '@mui/material'
import { School } from '@mui/icons-material'
import { TopCourse } from '../../types'

interface TopCoursesProps {
  data: TopCourse[]
}

export default function TopCourses({ data }: TopCoursesProps) {
  // Limit to top 6 courses for layout purposes
  let topCourses = data.slice(0, 6)

  return (
    <Paper sx={{ p: 3 }}>
      <Typography
        variant="h6"
        sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <School />
        Top Courses
      </Typography>

      <Box className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {topCourses.map((course) => (
          <Box key={course.courseName}>
            <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 1,
                  fontWeight: 600,
                  minHeight: '2.5em',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {course.courseName}
              </Typography>
              <Typography variant="h6" color="primary.main" sx={{ mb: 0.5 }}>
                {course.totalHours}h
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {course.activityCount}{' '}
                {course.activityCount === 1 ? 'completion' : 'completions'}
              </Typography>
            </Card>
          </Box>
        ))}
      </Box>

      {data.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body2" color="text.secondary">
            No course data available for the selected period
          </Typography>
        </Box>
      )}
    </Paper>
  )
}
